<template>
	<div class="about">
		<my-header active="8" />
		<div class="main">
			<div class="container">
				<div class="current ">
					<p>当前位置：首页>关于我们</p>
				</div>
				<div class="warp">
					<examination-sidebar />
					<div class="sidebar-right">
						<div class="title">
							<h1>关于我们<span> / About Us</span>	</h1>
						</div>
						<div v-html="data1"></div>
					</div>
				</div>
				<!-- <div class="brief " v-if="pic1">
					<div class="box">
						<img src="../assets/images/public/about.jpg" />
						<div  v-html="data1"></div>
					</div>
					<div class="box">
						<img :src="pic1" />
					</div> 
				</div>-->
				<!-- <div class="title">
					<h1>联系我们  <span> / Contact  us</span>	</h1>
				</div>
				<div class="contact">
					<div class="map">
						<el-amap :center="center" :zoom="zoom">
							<el-amap-info-window :position="center" :content="content" />
						</el-amap>
					</div>
					<div class="mode">
						<div v-html="data2"></div>
					</div>
				</div> -->
			</div>
		</div>
		<my-footer />
	</div>
</template>

<script>
import { articleList} from '@/api/cms'
import { noticeDetail } from '@/api/center'
import { fetchArticle } from '@/api/article'

export default {
	name: 'about',
	components: {

	},
	data(){
		return {
			zoom: 16,
			center:[116.600175,39.927092],
			content:'北京市朝阳区常慧路6号V中心B座1407室',
			data1:'',
			pic1:'',
			data2:''
		}
	},
	mounted(){
		articleList({ pageNum: 1, pageSize: 6, type: 11 }).then(res => {
			if(res.list){
				fetchArticle({id:res.list[0].id}).then(ress=>{
					this.data1=ress.content
					this.pic1=ress.files[0].fileUrl
				})
			}
		})
		articleList({ pageNum: 1, pageSize: 6, type: 12 }).then(res => {
			if(res.list){
				fetchArticle({id:res.list[0].id}).then(ress=>{
					console.log(ress)
					this.data2=ress.content
				})
			}
		})
	}
}
</script>

<style scoped>
	.map{width: 770px;height: 344px;}
	.brief{
		padding: 50px;
		display: flex;
		justify-content: space-between;
	}
	.brief .box{
		width: 540px;
	}
	.brief .box h1{
		font-size: 14px;
		font-weight: bold;
		color: #000;
	}
	.brief .box p{
		padding-top: 10px;
		line-height: 20px;
	}
	.contact{
		display: flex;
		margin: 20px 0;
	}
	.mode{
		padding-left: 30px;
		color: #000;
	}
	.mode h1{
		font-size: 16px;
		font-weight: 900;
	}
	/* .mode h1,p{
		line-height: 36px;
	} */
	.mode img{
		width: 175px;
	}
</style>
